import { render, staticRenderFns } from "./MergeFoldersModal.vue?vue&type=template&id=52d0db8e"
import script from "./MergeFoldersModal.vue?vue&type=script&lang=ts"
export * from "./MergeFoldersModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports